export const ImageViewer = ({ path }) => {
  return (
    <div style={{ width: "100%" }}>
      <img src={path} />
    </div>
  );
};
